<template>
  <div>
    <!--begin::Body-->
    <div class="kt-login__body">
      <!--begin::Signin-->
      <div class="kt-login__form">
        <router-link to="/">
          <img :src="siteLogo" alt="" class="logo-login" />
        </router-link>
        <div class="kt-login__title login-title">
          <h3>{{ $t("TO_PROCEED_ENTER_EMAIL_CODE") }}</h3>
        </div>

        <!--begin::Form-->
        <b-form class="kt-form login-form" @submit.stop.prevent="onSubmit">
          <div
            role="alert"
            v-bind:class="{ show: errors.length }"
            class="alert fade alert-success"
          >
            <div class="alert-text">
              {{ $t("PASSWORD_RESET_LINK_SENT") }}
            </div>
          </div>

          <b-form-group id="code-input-group" label="" label-for="code-input">
            <b-form-input
              id="code-input"
              name="code"
              v-model="$v.form.code.$model"
              :state="validateState('code')"
              aria-describedby="code-input-live-feedback"
              v-bind:placeholder="$t('CODE')"
            ></b-form-input>

            <b-form-invalid-feedback id="code-input-live-feedback">
              {{ $t("ENTER_VALID_CODE") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <div class="kt-login__actions">
            <router-link to="/login">
              <a class="kt-link kt-login__link-forgot">
                {{ $t("LOGIN") }}
              </a>
            </router-link>

            <b-button
              type="submit"
              id="kt_submit"
              class="btn btn-success btn-elevate kt-login__btn-primary"
            >
              {{ $t("READY") }}
            </b-button>
          </div>
          <!--end::Action-->
          <!--end::Action-->
        </b-form>
        <!--end::Form-->
      </div>
      <!--end::Signin-->
    </div>
    <!--end::Body-->
  </div>
</template>

<style lang="scss" scoped>
.kt-spinner.kt-spinner--right:before {
  right: 8px;
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import { TWOFACTOR } from "@/store/auth.module";

import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "twoFactor",
  data() {
    return {
      form: {
        code: ""
      }
    };
  },
  mounted() {
    // check if current user is authenticated
    if (this.isAuthenticated) {
      this.$router.push({ name: "dashboard" });
    }
  },
  validations: {
    form: {
      code: {
        required,
        minLength: minLength(6)
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        code: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const code = this.$v.form.code.$model;

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add(
        "kt-spinner",
        "kt-spinner--light",
        "kt-spinner--right"
      );

      // send login request
      this.$store
        .dispatch(TWOFACTOR, { code })
        // go to which page after successfully login
        .then(() => {
          this.$router.push({ name: "dashboard" });
        })
        .finally(() => {
          submitButton.classList.remove(
            "kt-spinner",
            "kt-spinner--light",
            "kt-spinner--right"
          );
        });
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    ...mapState({
      errors: state => state.auth.errors
    }),
    siteLogo() {
      return process.env.BASE_URL + "assets/media/logos/logo.png";
    }
  }
};
</script>
